import { render, staticRenderFns } from "./coderInpatientDxs.vue?vue&type=template&id=62558d21&scoped=true&"
import script from "./coderInpatientDxs.vue?vue&type=script&lang=js&"
export * from "./coderInpatientDxs.vue?vue&type=script&lang=js&"
import style0 from "./coderInpatientDxs.vue?vue&type=style&index=0&id=62558d21&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62558d21",
  null
  
)

export default component.exports